import { wrapSvg } from '../../util/SvgImage';

export const IconInfo = wrapSvg(
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C6.48583 2 2 6.48583 2 12C2 17.5142 6.48583 22 12 22C17.5142 22 22 17.5142 22 12C22 6.48583 17.5142 2 12 2ZM11 6.99731C11 6.44651 11.4477 6 12 6C12.5523 6 13 6.44651 13 6.99731V7.49597C13 8.04677 12.5523 8.49328 12 8.49328C11.4477 8.49328 11 8.04677 11 7.49597V6.99731ZM9 10.4879C9 11.0387 9.44772 11.4852 10 11.4852H11V15.4745H10C9.44772 15.4745 9 15.921 9 16.4718C9 17.0226 9.44772 17.4691 10 17.4691H14C14.5523 17.4691 15 17.0226 15 16.4718C15 15.921 14.5523 15.4745 14 15.4745H13V10.4879C13 9.93708 12.5523 9.49057 12 9.49057H10C9.44772 9.49057 9 9.93708 9 10.4879Z"
      fill="#072326"
    />
  </svg>,
);
